
/**
 * @export
 * @enum {string}
 */
export enum EventType {
    USER_EVENT = 'USER_EVENT',
    SYSTEM_EVENT = 'SYSTEM_EVENT'
}